module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_3009.cd1c9434.png";